import type { IMandateSummary } from './trading-governance.api';

export type TStatusTone = 'success' | 'warning' | 'error' | 'muted';

const ACTION_LABELS: Record<string, string> = {
  AddTrader: 'Add Trader',
  UpdateTradingMandate: 'Update Trading Mandate',
  RemoveTrader: 'Remove Trader',
  AddBusinessAdmin: 'Add Business Admin',
  Withdrawal: 'Withdrawal',
};

const STATUS_LABELS: Record<string, string> = {
  PendingApproval: 'Pending Approval',
  Executed: 'Completed',
};

const STATUS_TONES: Record<string, TStatusTone> = {
  Draft: 'warning',
  PendingApproval: 'warning',
  Approved: 'success',
  Executing: 'warning',
  Executed: 'success',
  Rejected: 'error',
  Expired: 'error',
  Failed: 'error',
  Cancelled: 'muted',
};

const IN_PROGRESS_STATUSES = ['Draft', 'PendingApproval', 'Approved', 'Executing'];

export const governanceActionLabel = (actionType: string) => ACTION_LABELS[actionType] || actionType;

export const governanceStatusLabel = (status: string) => STATUS_LABELS[status] || status;

export const governanceStatusTone = (status: string): TStatusTone => STATUS_TONES[status] || 'muted';

export const isGovernanceRequestInProgress = (status: string) => IN_PROGRESS_STATUSES.includes(status);

export const mandateScopeLabel = (mandate?: IMandateSummary | null) => {
  if (!mandate) {
    return '';
  }

  const markets = mandate.marketIds.length === 1 ? '1 market' : `${mandate.marketIds.length} markets`;
  return [mandate.marketTypes.join(', '), markets].filter(Boolean).join(' · ');
};
